<template>
  <v-dialog v-model="show_message" :persistent="persistent" max-width="500">
    <v-card>
      <v-card-title class="headline">{{title}}</v-card-title>
      <v-card-text v-html="message"></v-card-text>
      <v-card-actions>
        
        <v-spacer></v-spacer>
        <div v-for="(action, index) in actions" v-bind:key="index">

          <v-btn 
            name="aceptar"
            :color="action['prin'] ? 'white' : 'primary darken-1'"
            :class="{
              'primary-bckground': action['prin']
            }"
            text 
            :outlined="action['prin']"
            @click="doEmit(action['emit'])"
          >
            {{ action['action_text'] }}
          </v-btn>

        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'MessagePopup',
  props: {
    title: {
      type:String,
      required:false,
      default:''
    },
    message: {
      type: String,
      required: true
    },
    show_message: {
      type: Boolean,
      required: true
    },
    persistent: {
      type:Boolean,
      required:false,
      default:true,
    },
    // is_payment_msg: {
    //   type: Boolean,
    //   required: false,
    //   default: false,
    // },
    actions: {
      type: Array,
      required: false,
      default: function () {
        return [{ 'action_text': 'OK', 'emit': 'close-message', 'prin': true }];
      }
    },
  },
  methods:{
    closeMessage(){
      this.$emit("close-message");
    },
    
    doEmit(emit) {
      this.$emit(emit);
    }
  }
}
</script>

<style lang="scss" scoped>

  .primary-bckground {
    background-color: #663399;
  }
  .primary-border {
    border-color: #663399 !important;
  }
</style>

